import CampaignPerformance from "Components/campaigns/insights/CampaignPerformance"
import CollaborationsTable from "Components/campaigns/insights/CollaborationsTable"
import OverallCollaboration from "Components/campaigns/insights/OverallCollaboration"
import SocialPerformance from "Components/campaigns/insights/SocialPerformance"
import { PRIVILEGE } from "constants/privilege"
import withAccessControl from "hoc/withAccessControl"
import useDocumentTitle from "hooks/useDocumentTitle"
import CampaignLayout from "Layouts/CampaignLayout"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { fetchCampaignInsights } from "slices/campaigns/insights/thunk"
import { fetchCampaignPerformance } from "slices/campaigns/performance/thunk"
import { AppDispatch } from "store"

const CampaignInsights = () => {

    useDocumentTitle("Insights - Campaign");

    const dispatch: AppDispatch = useDispatch();
    const { campaignId } = useParams();

    useEffect(() => {
        if (campaignId) {
            dispatch(fetchCampaignInsights({ campaignId }));
            dispatch(fetchCampaignPerformance({campaignId}));
        }
    }, [dispatch, campaignId])

    return (
        <CampaignLayout
            // filters={<button className="theme-btn btn-primary"><i className='bx bxs-report me-1' ></i>Download Report</button>}
        >
            <div className="row d-flex">
                <div className="col-lg-4">
                    <div className="d-flex flex-column">
                        <OverallCollaboration />
                        <SocialPerformance />
                    </div>
                </div>
                <div className="col-lg-8 mt-4 mt-lg-0">
                    <div className="card h-100">
                        <CampaignPerformance />
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <CollaborationsTable />
                </div>
            </div>
        </CampaignLayout>
    )
}

export default withAccessControl(CampaignInsights, PRIVILEGE.CAMPAIGN.PERFORMANCE.INDEX)